import React, { Component } from 'react';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';

const editorBtns = [
    ['undo', 'redo'],
    ['bold', 'italic', 'underline', 'strike'],
    ['fontSize', 'formatBlock'],
    ['fontColor', 'hiliteColor'],
    ['paragraphStyle', 'lineHeight'],
    ['list', 'align'],
    ['image', 'link', 'horizontalRule'],
    ['removeFormat']
];
const editorDefaultStyle = 'font-size: 16px; line-height: 1.75;';

export class AboutSettings extends Component {
    constructor(props) {
        super(props);
        this.state = { values: {}, loading: true, saving: false, saved: false, uploading: false };
    }

    componentDidMount() { this.load(); }

    load() {
        this.setState({ loading: true });
        fetch('api/sitesetting')
            .then(r => r.ok ? r.json() : {})
            .then(values => this.setState({ values: values || {}, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    upd(key, val) { this.setState({ values: { ...this.state.values, [key]: val }, saved: false }); }

    async uploadImage() {
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = async (e) => {
            if (!e.target.files[0]) return;
            this.setState({ uploading: true });
            var fd = new FormData();
            fd.append('file', e.target.files[0]);
            fd.append('folder', 'about');
            try {
                var r = await fetch('api/programplus/upload', { method: 'POST', body: fd });
                var res = await r.json();
                this.upd('about_image', res.path);
            } catch {}
            this.setState({ uploading: false });
        };
        input.click();
    }

    async save() {
        this.setState({ saving: true, saved: false });
        try {
            var r = await fetch('api/sitesetting', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ values: this.state.values })
            });
            if (!r.ok) throw new Error('save failed');
            this.setState({ saved: true, saving: false });
            setTimeout(() => this.setState({ saved: false }), 2500);
        } catch (e) {
            alert('บันทึกไม่สำเร็จ: ' + e.message);
            this.setState({ saving: false });
        }
    }

    render() {
        var { values, loading, saving, saved, uploading } = this.state;
        if (loading) return <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>;

        return (
            <div style={{ padding: '28px 20px 40px', maxWidth: 1000, margin: '0 auto' }}>
                <div className="d-flex justify-content-between align-items-center mb-4" style={{ flexWrap: 'wrap', gap: 12 }}>
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>
                        <i className="fas fa-info-circle" style={{ color: '#dc3545', marginRight: 6 }}></i>
                        เนื้อหา "เกี่ยวกับเรา" ที่จะแสดงบนหน้า Home และหน้า About
                    </p>
                    <div className="d-flex" style={{ gap: 10 }}>
                        {saved && <span style={{ color: '#28a745', fontSize: 13, alignSelf: 'center', fontWeight: 600 }}><i className="fas fa-check-circle"></i> บันทึกแล้ว</span>}
                        <button className="btn btn-danger px-4" onClick={() => this.save()} disabled={saving} style={{ minWidth: 140 }}>
                            {saving ? <><i className="fas fa-spinner fa-spin"></i> กำลังบันทึก...</> : <><i className="fas fa-save"></i> บันทึก</>}
                        </button>
                    </div>
                </div>

                <div style={{ background: '#fff', borderRadius: 12, padding: '24px 28px 28px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: 22 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingBottom: 14, marginBottom: 20, borderBottom: '1px solid #f0f0f0' }}>
                        <span style={{ width: 36, height: 36, borderRadius: 8, background: 'linear-gradient(135deg,#dc3545,#9d1a26)', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 15 }}>
                            <i className="fas fa-info-circle"></i>
                        </span>
                        <div style={{ fontSize: 16, fontWeight: 800, color: '#333' }}>เกี่ยวกับเรา</div>
                    </div>

                    <div className="mb-4">
                        <label style={{ fontSize: 13, fontWeight: 700, color: '#555', marginBottom: 8, display: 'block' }}>หัวข้อ</label>
                        <input className="form-control" value={values.about_title || ''} onChange={e => this.upd('about_title', e.target.value)} placeholder="เช่น ยินดีต้อนรับสู่ ANT Journey House" />
                    </div>

                    <div className="mb-4">
                        <label style={{ fontSize: 13, fontWeight: 700, color: '#555', marginBottom: 8, display: 'block' }}>คำโปรย (ใต้หัวข้อ)</label>
                        <input className="form-control" value={values.about_subtitle || ''} onChange={e => this.upd('about_subtitle', e.target.value)} placeholder="เช่น ออกเดินทางสู่ประสบการณ์ที่น่าจดจำ กับทีมงานมืออาชีพ" />
                    </div>

                    <div className="mb-4">
                        <label style={{ fontSize: 13, fontWeight: 700, color: '#555', marginBottom: 8, display: 'block' }}>ภาพประกอบ</label>
                        <div onClick={() => this.uploadImage()} style={{ width: '100%', height: 220, border: '2px dashed #ccc', borderRadius: 8, cursor: 'pointer', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa' }}>
                            {values.about_image ? <img src={values.about_image} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (
                                <div style={{ textAlign: 'center', color: '#999' }}>
                                    <i className="fas fa-cloud-upload-alt fa-2x"></i>
                                    <div style={{ marginTop: 8, fontSize: 13 }}>{uploading ? 'กำลังอัปโหลด...' : 'คลิกเพื่ออัปโหลดรูป'}</div>
                                </div>
                            )}
                        </div>
                        {values.about_image && (
                            <button className="btn btn-outline-secondary btn-sm mt-2" onClick={() => this.upd('about_image', '')}>
                                <i className="fas fa-times"></i> ลบรูป
                            </button>
                        )}
                    </div>

                    <div>
                        <label style={{ fontSize: 13, fontWeight: 700, color: '#555', marginBottom: 8, display: 'block' }}>เนื้อหา</label>
                        <SunEditor
                            setContents={values.about_content || ''}
                            onChange={c => this.upd('about_content', c)}
                            setDefaultStyle={editorDefaultStyle}
                            setOptions={{ height: 400, buttonList: editorBtns }}
                        />
                    </div>
                </div>

                <div className="d-flex justify-content-end" style={{ gap: 10 }}>
                    {saved && <span style={{ color: '#28a745', fontSize: 13, alignSelf: 'center', fontWeight: 600 }}><i className="fas fa-check-circle"></i> บันทึกแล้ว</span>}
                    <button className="btn btn-danger px-4" onClick={() => this.save()} disabled={saving} style={{ minWidth: 140 }}>
                        {saving ? <><i className="fas fa-spinner fa-spin"></i> กำลังบันทึก...</> : <><i className="fas fa-save"></i> บันทึก</>}
                    </button>
                </div>
            </div>
        );
    }
}
